import { MfeLoad } from '@carvana/microfrontend';

export const getMfeCacheBuster = () => {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;
  return `${date.getDate()}-${date.getHours()}-${nearestQuarterHour}`;
};

export const SoftPullMfeConfig = () =>
  MfeLoad({
    files: [
      [
        'SoftPullModule',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CARVANA_APP_CDN_URL_FASTLY
              }/softpull/module/assets-manifest.json?v=${getMfeCacheBuster()}`
            }
          }
        ]
      ]
    ]
  });
